import { render, staticRenderFns } from "./RoccSeverityEditor.vue?vue&type=template&id=190c89ef&"
import script from "./RoccSeverityEditor.vue?vue&type=script&setup=true&lang=ts&"
export * from "./RoccSeverityEditor.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports